function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5,12 C12.671,12 12,11.328 12,10.5 C12,9.672 12.671,9 13.5,9 C14.329,9 15,9.672 15,10.5 C15,11.328 14.329,12 13.5,12 M6.5,12 C5.671,12 5,11.328 5,10.5 C5,9.672 5.671,9 6.5,9 C7.329,9 8,9.672 8,10.5 C8,11.328 7.329,12 6.5,12 M18.332,8.272 C18.074,8.166 17.865,7.953 17.774,7.689 C17.231,6.125 15.75,5 14,5 L11.5,5 C11.224,5 11,4.776 11,4.5 L11,2.988 C11,2.788 11.049,2.583 11.174,2.427 C11.377,2.172 11.5,1.852 11.5,1.5 C11.5,0.672 10.829,0 10,0 C9.171,0 8.5,0.672 8.5,1.5 C8.5,1.852 8.623,2.172 8.826,2.426 C8.951,2.583 9,2.788 9,2.988 L9,4.5 C9,4.776 8.776,5 8.5,5 L6,5 C4.251,5 2.769,6.125 2.226,7.689 C2.135,7.953 1.926,8.166 1.668,8.272 C0.682,8.68 0,9.52 0,10.5 C0,11.405 0.581,12.191 1.446,12.628 C1.783,12.798 2,13.139 2,13.517 L2,17 C2,17.553 2.448,18 3,18 L17,18 C17.552,18 18,17.553 18,17 L18,13.517 C18,13.139 18.217,12.798 18.554,12.628 C19.419,12.191 20,11.405 20,10.5 C20,9.52 19.318,8.68 18.332,8.272",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -1 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/bot.3030fe7d.svg";
export { SvgComponent as ReactComponent };